import { doc, setDoc, deleteDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig"; // Đường dẫn này tuỳ cấu trúc dự án của bạn

// Thêm học viên vào lớp (tạo doc enrollments)
export async function addStudentToClass(classId, student) {
  if (!classId || !student?.id) return;
  await setDoc(doc(db, "classes", classId, "enrollments", student.id), {
    status: "active",
    enrolledAt: serverTimestamp(),
  });
}

// Gỡ học viên khỏi lớp (xoá doc enrollments)
export async function removeStudentFromClass(classId, studentId) {
  if (!classId || !studentId) return;
  await deleteDoc(doc(db, "classes", classId, "enrollments", studentId));
}

// Cập nhật trạng thái học viên trong lớp
export async function updateStudentStatus(classId, studentId, status, note) {
  if (!classId || !studentId || !status) return;
  await updateDoc(doc(db, "classes", classId, "enrollments", studentId), {
    status,
    updatedAt: serverTimestamp(),
    ...(note !== undefined ? { note } : {}),
  });
}
